import { useEffect } from 'react';
import noop from 'lodash-es/noop';

const useSubscription = (topic, callback) => {
  useEffect(() => {
    if (window.zpayapi) {
      const sub = window.zpayapi.subscribe(topic, payload => callback(payload));
      return sub.remove;
    }
    return noop;
  }, [callback]);
};

export default useSubscription;
